
import React, { useState } from "react";
import "../styles/TrackPage.css";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";



const TrackPage = () => {
  const location = useLocation();
  const [trackingId, setTrackingId] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const queryRef = params.get("ref");
  
    const pathParts = location.pathname.split("/");
    const pathRef = pathParts[pathParts.length - 1];
  
    const trackingId = queryRef || (pathRef?.startsWith("CJET-") ? pathRef : null);
    if (trackingId) setTrackingId(trackingId);
  }, [location]);
  const [trackingInfo, setTrackingInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleTrack = async () => {
    if (!trackingId.trim()) return;
    setLoading(true);
    setTrackingInfo(null);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/track/${trackingId}`
      );
      const result = await res.json();

      if (result.success) {
        setTrackingInfo(result.data);
      } else {
        setTrackingInfo({ error: result.error || "Tracking not found" });
      }
    } catch (err) {
      setTrackingInfo({ error: "Something went wrong" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="track-container">
      <h2>📦 Track Your Dispatch</h2>
      <input
        type="text"
        placeholder="Enter Tracking Number or CJET ID"
        value={trackingId}
        onChange={(e) => setTrackingId(e.target.value)}
        className="track-input"
      />
      <button
        onClick={handleTrack}
        disabled={!trackingId}
        className="track-button"
      >
        {loading ? "Checking..." : "Track"}
      </button>

      {trackingInfo && (
        <div className="track-results">
          {trackingInfo.error ? (
            <p className="error">{trackingInfo.error}</p>
          ) : (
            <>
              <p><strong>CJET ID:</strong> {trackingInfo.cjetTrackingId}</p>
              <p><strong>Carrier:</strong> {trackingInfo.carrier}</p>
              <p><strong>Carrier Tracking #:</strong> {trackingInfo.carrierTrackingNumber}</p>
              <p><strong>Status:</strong> {trackingInfo.status}</p>
              <p><strong>Last Update:</strong> {new Date(trackingInfo.last_update).toLocaleString()}</p>
              {trackingInfo.carrierTrackingUrl && (
                <a href={trackingInfo.carrierTrackingUrl} target="_blank" rel="noopener noreferrer">
                  View Full Carrier Tracking
                </a>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default TrackPage;